import React from 'react';
import { AuthProvider } from './context/AuthContext';
import { DeliveryProvider } from './context/DeliveryContext';
import Locate2uPortal from './components/Locate2uPortal';

function App() {
  return (
    <AuthProvider>
      <DeliveryProvider>
        <Locate2uPortal />
      </DeliveryProvider>
    </AuthProvider>
  );
}

export default App;
